import { t } from '@/i18n/i18ns'
import { asyncValidationRule, asyncFormValidation } from '@/element-ui/form-utils'
import _ from 'lodash'

export const validateEmptyFields = (errorMessage) => {
  return asyncValidationRule(async (rule, value) => {
    if (_.isEmpty(value)) {
      return new Error(errorMessage)
    }
  })
}

export default {
  name: 'assign-license-component',
  inject: [
    '$utils',
    '$api'
  ],
  components: {
  },
  props: { },
  data () {
    return {
      model: {
        comment: '',
        playerSerialNumber: null,
        licenseCode: ''
      },
      modelRules: {
        licenseCode: [
          { validator: validateEmptyFields(t('activation.licenseCodeRequired')), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    async commitAssignLicenseCode () {
      const data = {
        serialNumber: this.model.playerSerialNumber,
        activationCode: this.model.licenseCode,
        label: this.model.comment
      }
      const responseData = await this.$utils.apiRequest(() => this.$api.post(`${CONFIG.API_BASE_URL}/licenses/active`, data), 'Unable to assign a license', true)

      return !_.isEmpty(responseData) ? responseData : null
    },
    refreshForm () {
      this.$refs.refAssignPlayerLicenseForm.clearValidate()
      this.model = {
        comment: '',
        playerSerialNumber: null,
        licenseCode: ''
      }
    },
    async isFormValid () {
      try {
        const isValid = await asyncFormValidation(this.$refs.refAssignPlayerLicenseForm)
        return isValid
      } catch (error) {
        return false
      }
    },
    async handleSubmitForm () {
      if (await this.isFormValid()) {
        const data = await this.commitAssignLicenseCode()

        if (!_.isEmpty(data)) {
          this.$emit('newAssignedLicense', data)
          this.refreshForm()
        }
      }
    }
  },
  mounted () {}
}
